import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import type { LocationId } from "../data/locations";
type Language = "en" | "es";
type SiteContextValue = {
  language: Language;
  setLanguage: (language: Language) => void;
  selectedLocation: LocationId;
  setSelectedLocation: (location: LocationId) => void;
  t: (english: string, spanish: string) => string;
};
const SiteContext = createContext<SiteContextValue | null>(null);
function readPreference(key: string) {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}
function savePreference(key: string, value: string) {
  try {
    window.localStorage.setItem(key, value);
  } catch {/* Keep the in-memory preference when storage is blocked. */}
}
export function SiteProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [language, setLanguageState] = useState<Language>(() => readPreference("agave-language") === "es" ? "es" : "en");
  const [selectedLocation, setSelectedLocationState] = useState<LocationId>(() => readPreference("agave-location") === "victor" ? "victor" : "driggs");
  const setLanguage = (next: Language) => {
    savePreference("agave-language", next);
    setLanguageState(next);
  };
  const setSelectedLocation = (next: LocationId) => {
    savePreference("agave-location", next);
    setSelectedLocationState(next);
  };
  useEffect(() => {
    document.documentElement.lang = language;
  }, [language]);
  const value = useMemo(() => ({
    language,
    setLanguage,
    selectedLocation,
    setSelectedLocation,
    t: (english: string, spanish: string) => language === "en" ? english : spanish
  }), [language, selectedLocation]);
  return <SiteContext.Provider value={value} data-id="element-423" data-mp="1uc3lt5y83sm8">{children}</SiteContext.Provider>;
}
export function useSite() {
  const context = useContext(SiteContext);
  if (!context) throw new Error("useSite must be used within SiteProvider");
  return context;
}